import { SmartShape } from "appworks/graphics/elements/smart-shape";
import { Sprite } from "appworks/graphics/pixi/sprite";
import { AbstractControl } from "appworks/ui/controls/abstract-control";
import { uiFlags, UIMenuFlag } from "appworks/ui/flags/ui-flags";

export class EpicAutoplayMenuControl extends AbstractControl {
    constructor(protected backgroundOverlay: SmartShape, protected menuBackground: Sprite) {
        super();

        backgroundOverlay.interactive = true;
        menuBackground.interactive = true;

        backgroundOverlay.addListener("pointerdown", () => {
            uiFlags.menu(UIMenuFlag.AUTO, false);
        });
    }
}
